import React from "react";

// Stil dosyamızı import edelim
import "./ServicesGrid.scss";

// Kart arkaplan desenini import edelim
import cardBgPattern from "../../assets/images/services-card-bg-pattern.png";

import hizmetlerGenelMuayene from "../../assets/images/hizmetler-muayene.jpeg";
import hizmetlerKoruyucuHekimlik from "../../assets/images/hizmetler-kontrol.jpeg";
import hizmetlerAsiUygulamalari from "../../assets/images/hizmetler-asi.jpeg";
import hizmetlerGenelCerrahi from "../../assets/images/hizmetler-cerrahi.jpeg";
import hizmetlerDogumveJinekoloji from "../../assets/images/hizmetler-dogum.jpeg";
import hizmetlerLab from "../../assets/images/hizmetler-lab.jpeg";

// Kartların verilerini bir dizi olarak tanımlıyoruz
// Her bir kart için ikon görselini ve metinleri buraya gireceğiz
const servicesData = [
  {
    image: hizmetlerGenelMuayene, // public klasöründeki yolu kullanmak daha kolay olabilir
    title: "Genel Muayene",
    description:
      "Evcil dostlarınızın sağlık sorunlarını detaylı inceleyerek doğru teşhis ve tedavi sunuyoruz",
  },
  {
    image: hizmetlerKoruyucuHekimlik,
    title: "Koruyucu Hekimlik",
    description:
      "Hastalıkları önlemek için düzenli kontroller ve kişiselleştirilmiş koruyucu tedavi hizmetleri sağlıyoruz",
  },
  {
    image: hizmetlerAsiUygulamalari,
    title: "Aşı Uygulamaları",
    description:
      "Patili dostlarınızın sağlığını korumak için gerekli tüm aşıları güvenle uyguluyoruz",
  },
  // {
  //   icon: "/services-icon3.png",
  //   title: "Pet Shop Hizmetleri",
  //   description:
  //     "Evcil dostlarınızın ihtiyaçlarını karşılayacak kaliteli ve güvenilir ürünler sunuyoruz.",
  // },
  // {
  //   icon: "/services-icon4.png",
  //   title: "Hayvan Kuaförü",
  //   description:
  //     "Hayvan dostlarınız için özenli bakım ve profesyonel tımar hizmetleri sağlıyoruz",
  // },
  {
    image: hizmetlerGenelCerrahi,
    title: "Genel Cerrahi",
    description:
      "Hayvanlarınızın cerrahi ihtiyaçlarında güvenilir ve modern müdahalelerle yanınızdayız",
  },
  {
    image: hizmetlerDogumveJinekoloji,
    title: "Doğum ve Jinekoloji",
    description:
      "Üreme sağlığı ve doğum sürecinde uzman desteğimizle her adımda yanınızdayız",
  },
  {
    image: hizmetlerLab,
    title: "Laboratuvar Hizmetleri",
    description:
      "Hızlı ve doğru teşhis için gelişmiş laboratuvar hizmetleriyle sağlık sürecinizi destekliyoruz",
  },
];

// Tek bir kart component'i
const ServiceCard = ({ image, title, description }) => {
  return (
    <div className="service-card">
      {/* Görselin üst kısmı tamamen kaplaması için yeni div */}
      <div className="service-card__image-container">
        <img src={image} alt={title} className="service-card__image" />
      </div>

      {/* Metin içeriği için yeni div */}
      <div className="service-card__content">
        <h3 className="service-card__title">{title}</h3>
        <p className="service-card__description">{description}</p>
      </div>

      {/* Eski pati deseni artık kartın içinde değil, genel arka planda */}
      {/* <img src={cardBgPattern} alt="" className="service-card__bg-pattern" /> */}
    </div>
  );
};

// 8 kartı içeren ana component
const ServicesGrid = () => {
  return (
    <div className="services-grid-container">
      {servicesData.map((service, index) => (
        <ServiceCard
          key={index}
          image={service.image}
          title={service.title}
          description={service.description}
        />
      ))}
    </div>
  );
};

export default ServicesGrid;
